import { render, staticRenderFns } from "./ItemPrice.vue?vue&type=template&id=4f6929e3&"
import script from "./ItemPrice.vue?vue&type=script&lang=js&"
export * from "./ItemPrice.vue?vue&type=script&lang=js&"
import style0 from "./ItemPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports